export default "__VITE_ASSET__D06H8Oca__"